import { Box, Grid, Skeleton, Typography } from "@mui/material";
import parse from 'html-react-parser';
import React from "react";

interface Props<T> {
  children?: React.ReactElement<unknown>
  data: T
  columns: Array<GridTableColumn<T>>
  isLoading?: boolean
  color?: 'light' | 'dark'
}

export default function GridTable<T>(props: Props<T>) {
  return (
    <Box sx={(theme) => ({
      padding: '1rem',
      [theme.breakpoints.up('md')]: {
        padding: '2rem',
      },
      '.th': {
        padding: '1rem 0.5rem',
        borderTop: '5px solid',
        borderTopColor: theme.palette.grey[props.color === 'light' ? 900 : 500],
        [theme.breakpoints.up('md')]: {
          padding: '1.5rem 0.5rem',
        },
        '& p': {
          fontSize: '1.2rem',
          fontWeight: 'bold',
        }
      },
      '.td': {
        padding: '1rem 0.5rem',
        borderTop: '5px solid',
        borderColor: theme.palette.grey[props.color === 'light' ? 500 : 50],
        [theme.breakpoints.up('md')]: {
          padding: '3rem 0.5rem',
        },
        '& p': {
          fontSize: '1rem',
        }
      }
    })}>
      <Grid container>
        {props.columns.filter(c => !c.hidden).map((column, index) => {
          return (
            <React.Fragment key={index}>
              <Grid size={{ xs: 12, md: 2 }}>
                <Box className="th">
                  <Typography variant="body1">{column.label}</Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 10 }}>
                <Box className="td">
                  {
                    column.renderCell ?
                      column.renderCell(props.data, index)
                      :
                      <Typography
                        variant="body1"
                        component="div"
                      >
                        {props.isLoading ?
                          <Skeleton animation="wave" width={'50%'} />
                          :
                          parse(props.data[column.field] as string || '')
                        }
                      </Typography>
                  }
                </Box>
              </Grid>
            </React.Fragment>
          )
        })}
      </Grid>
    </Box>
  )
}